export default "__VITE_ASSET__DjatUFKa__"